import { combineReducers } from 'redux'

// ACTIONS
export const SET_IR_POSITION_ID = 'company/candidateDetails/interviewRequest/SET_FORM_POSITION_ID'

export const CREATE = 'company/candidateDetails/interviewRequest/CREATE'
export const CREATE_SUCCESS = 'company/candidateDetails/interviewRequest/CREATE_SUCCESS'

export const TOGGLE_CREATING = 'company/candidateDetails/interviewRequest/TOGGLE_CREATING'
export const TOGGLE_SHOW_FORM = 'company/candidateDetails/interviewRequest/TOGGLE_SHOW_FORM'

export const RESET = 'company/candidateDetails/interviewRequest/RESET'

export const SET_PENDING_COUNT_NO_POSITION = 'company/candidateDetails/interviewRequest/SET_PENDING_COUNT_NO_POSITION'

// ACTION CREATORS
export const create = (hiring_teams_id, isRecommendedCandidate, data, resolve, reject) => {
  const actionCreator = {
    type: CREATE,
    payload: { hiring_teams_id, isRecommendedCandidate, data },
    resolve,
    reject,
  }
  return actionCreator
}

export const createSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: { ...data },
})

export const toggleCreating = isCreating => ({
  type: TOGGLE_CREATING,
  payload: { isCreating },
})

export const toggleShowForm = showForm => ({
  type: TOGGLE_SHOW_FORM,
  payload: { showForm },
})

export const reset = () => ({
  type: RESET,
})

export const setIrPositionId = irPositionId => ({
  type: SET_IR_POSITION_ID,
  payload: irPositionId,
})

export const setPendingCountNoPosition = count => ({
  type: SET_PENDING_COUNT_NO_POSITION,
  payload: { pendingCountNoPosition: count },
})

// REDUCERS
const defaultUtils = {
  isCreating: false,
  showForm: false,
  usedTemplate: false,
  pendingCountNoPosition: 0,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_SHOW_FORM:
    case TOGGLE_CREATING:
    case SET_PENDING_COUNT_NO_POSITION:
      return {
        ...state,
        ...payload,
      }

    case CREATE_SUCCESS:
      return {
        ...state,
        usedTemplate: true,
      }

    case RESET:
      return {
        ...defaultUtils,
        usedTemplate: state.usedTemplate,
      }

    default:
      return state
  }
}

const selectedIrPositionId = (state = null, { type, payload }) => {
  switch (type) {
    case SET_IR_POSITION_ID:
      return payload

    default:
      return state
  }
}

export default combineReducers({
  utils,
  selectedIrPositionId,
})
